import { ErrorMessage, useFormikContext } from "formik";
import React, { useState } from "react";
import InputError from "../input-error/input-error";
import Textarea from "./textarea.component";

type FormikTextareaProps = {
  label?: string;
  name: string;
  id: string;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  showCount?: boolean;
  disabled?: boolean;
  className?: string;
};

const FormikTextarea: React.FC<FormikTextareaProps> = ({
  label,
  name,
  id,
  placeholder,
  rows,
  maxLength,
  showCount = false,
  disabled = false,
  className,
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const [errorMessage, setErrorMessage] = useState("");

  const currentValue =
    typeof values[name] === "string"
      ? values[name]
      : name.includes(".")
        ? name.split(".").reduce((obj, key) => obj?.[key], values) ?? ""
        : "";

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    if (maxLength && value.length > maxLength) {
      setErrorMessage(`Maximum character limit of ${maxLength} exceeded.`);
      return;
    }
    setErrorMessage("");
    setFieldValue(name, value);
  };

  return (
    <>
      <Textarea
        label={label}
        id={id}
        name={name}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        showCount={showCount}
        disabled={disabled}
        value={currentValue}
        onChange={handleChange}
        hasError={!!errorMessage}
        errorMessage={errorMessage}
        className={className}
      />
      <ErrorMessage name={name} component={InputError} />
    </>
  );
};

export default FormikTextarea;
